module.exports = __webpack_public_path__ + "static/media/Stoebern01.bccb7448.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Stoebern01.jpg
// module id = 355
// module chunks = 0